export default {
  content: require('./content').default,
}